"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = require("prop-types");

var Layers = (0, _createReactClass["default"])({
  displayName: 'Layers',
  propTypes: {
    children: _propTypes.any,
    map: _propTypes.object.isRequired
  },
  childContextTypes: {
    map: _propTypes.object.isRequired
  },
  getChildContext: function getChildContext() {
    return {
      map: this.props.map
    };
  },
  render: function render() {
    return _react["default"].createElement("div", null, this.props.children);
  }
});
var _default = Layers;
exports["default"] = _default;